<template>
  <div class="catalog-form">
    <h1>
      <i class="fal fa-arrow-circle-left" @click="onCancel" title="Regresar"></i>
      <span>{{ title }}</span>

      <div class="top-tool-bar flat actions">
        <div class="action" v-if="id" @click="init"><i class="fal fa-sync"></i> Refrescar</div>
        <div class="action" v-if="editButton" @click="onEdit"><i class="fal fa-file-edit"></i> Modificar</div>
      </div>
    </h1>

    <div class="menu-area hide-md">
      <div class="list-group">
        <a href="#init" class="list-group-item list-group-item-action" aria-current="true" v-if="id">
          Actualizaciones
        </a>
        <a href="#general" class="list-group-item list-group-item-action" aria-current="true">
          Información general
        </a>
        <a href="#contact" class="list-group-item list-group-item-action" aria-current="true">
          Datos de contacto
        </a>
        <a href="#address" class="list-group-item list-group-item-action" aria-current="true">
          Dirección fiscal
        </a>
        <a href="#other" class="list-group-item list-group-item-action" aria-current="true">
          Datos adicionales
        </a>
      </div>
    </div>

    <div class="form-area">
      <b-form @submit.stop.prevent="onSubmit" v-show="!loading">
        <b-card id="init" header="Actualizaciones" class="form-section" v-if="id">
          <table class="table table-responsive-md">
            <thead>
              <tr>
                <th scope="col">Evento</th>
                <th scope="col">Usuario</th>
                <th scope="col">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Creación</td>
                <td>{{ form.creationUser && form.creationUser.name || '--' }}</td>
                <td>{{ creationDate }}</td>
              </tr>
              <tr>
                <td>Actualización</td>
                <td>{{ form.updateUser && form.updateUser.name || '--' }}</td>
                <td>{{ updateDate || '--' }}</td>
              </tr>
              <tr>
                <td>Verificación</td>
                <td>{{ form.verificationUser && form.verificationUser.name || '--' }}</td>
                <td>{{ verificationDate || '--' }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>

        <!-- INFORMACION GENERAL -->
        <b-card id="general" header="Información general" class="form-section">
          <b-form-group
            id="input-group-code"
            label="Código de cliente *"
            label-for="input-code">
            <b-form-input
              id="input-code"
              name="input-code"
              type="text"
              class="shadow-none"
              placeholder="Identificador único de cliente (Ej. 000001)"
              v-model.trim="form.clientCode"
              :maxlength="6"
              v-validate="{ required: true, regex: regexClientCode }"
              :state="validateState('input-code')"
              aria-describedby="input-code-feedback"
              :disabled="readOnly">
            </b-form-input>
            <b-form-invalid-feedback id="input-code-feedback">Introduzca un código de 6 dígitos</b-form-invalid-feedback>
            <small v-if="form.id">ID de cliente: {{ form.id }} </small>
          </b-form-group>

          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group id="input-group-juridical-person" label="Personalidad jurídica *">
                <b-form-select
                  id="input-select-juridical-person"
                  name="input-select-juridical-person"
                  class="shadow-none"
                  v-model="form.juridicalPerson"
                  :options="juridicalPersonOptions"
                  v-validate="{ required: true }"
                  :state="validateState('input-select-juridical-person')"
                  :disabled="readOnly">
                </b-form-select>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-rfc"
                label="RFC *"
                label-for="input-rfc">
                <b-form-input
                  id="input-rfc"
                  name="input-rfc"
                  type="text"
                  class="shadow-none"
                  placeholder="RFC"
                  v-model.trim="form.rfc"
                  :maxlength="13"
                  v-validate="{ required: true, regex: form.juridicalPerson === 'moral' ? regexRfcPersonaMoral : regexRfcPersonaFisica  }"
                  :state="validateState('input-rfc')"
                  aria-describedby="input-rfc-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-rfc-feedback">Introduzca un RFC válido</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <b-form-group
            id="input-group-name"
            label="Razón social *"
            label-for="input-name">
            <b-form-input
              id="input-name"
              name="input-name"
              type="text"
              class="shadow-none"
              placeholder="Razón social"
              v-model.trim="form.name"
              :maxlength="255"
              v-validate="{ required: true }"
              :state="validateState('input-name')"
              aria-describedby="input-name-feedback"
              :disabled="readOnly">
            </b-form-input>
            <b-form-invalid-feedback id="input-name-feedback">La razón social es requerida</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="input-group-stp-clabe"
            label="Clabe stp"
            label-for="input-stp-clabe">
            <b-form-input
              id="input-stp-clabe"
              name="input-stp-clabe"
              type="text"
              class="shadow-none"
              placeholder="Clabe stp (18 dígitos)"
              v-model.trim="form.stpClabe"
              :maxlength="18"
              v-validate="{ regex: regexStpClabe  }"
              :state="validateState('input-stp-clabe')"
              aria-describedby="input-stp-clabe-feedback"
              :disabled="readOnly">
            </b-form-input>
            <b-form-invalid-feedback id="input-stp-clabe-feedback">La clave debe contener 18 caracteres alfanuméricos</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group id="input-group-status" label="Estatus">
            <b-form-select
              id="input-select-status"
              name="input-select-status"
              class="shadow-none"
              v-model="form.status"
              :options="statusOptions"
              :disabled="readOnly">
            </b-form-select>
          </b-form-group>

        </b-card>

        <!-- DATOS DE CONTACTO -->
        <b-card id="contact" header="Datos de contacto" class="form-section">
          <b-form-group
            id="input-group-contact-name"
            name="input-group-contact-name"
            label="Nombre de contacto *"
            label-for="input-contact-name">
            <b-form-input
              id="input-contact-name"
              name="input-contact-name"
              type="text"
              class="shadow-none"
              placeholder="Nombre"
              v-model.trim="form.contact.contactName"
              :maxlength="255"
              v-validate="{ required: true }"
              :state="validateState('input-contact-name')"
              aria-describedby="input-group-contact-name-feedback"
              :disabled="readOnly">
            </b-form-input>
            <b-form-invalid-feedback id="input-group-contact-name-feedback">El nombre de contacto es requerido</b-form-invalid-feedback>
          </b-form-group>

          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-email"
                label="Correo electrónico *"
                label-for="input-email">
                <b-form-input
                  id="input-email"
                  name="input-email"
                  type="email"
                  class="shadow-none"
                  placeholder="Para envío de factura electrónica"
                  v-model.trim="form.contact.email"
                  :maxlength="255"
                  v-validate="{ required: true, email: true  }"
                  :state="validateState('input-email')"
                  aria-describedby="input-email-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-email-feedback">Introduzca un correo válido</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-phone"
                label="Teléfono *"
                label-for="input-phone">
                <b-form-input
                  id="input-phone"
                  name="input-phone"
                  type="text"
                  class="shadow-none"
                  placeholder="Ej. 5537081925, +525537081925"
                  v-model.trim="form.contact.phone"
                  :maxlength="16"
                  v-validate="{ required: true, regex: regexPhone  }"
                  :state="validateState('input-phone')"
                  aria-describedby="input-phone-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-phone-feedback">Introduzca un teléfono válido</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-email-extra"
                label="Correo electrónico adicional"
                label-for="input-email-extra">
                <b-form-input
                  id="input-email-extra"
                  name="input-email-extra"
                  type="email"
                  class="shadow-none"
                  placeholder="Correo del cliente"
                  v-model.trim="form.contact.emailExtra"
                  :maxlength="255"
                  v-validate="{ email: true  }"
                  :state="validateState('input-email-extra')"
                  aria-describedby="input-email-extra-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-email-extra-feedback">Introduzca un correo válido</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-phone-extra"
                name="input-group-phone-extra"
                label="Teléfono adicional"
                label-for="input-phone-extra">
                <b-form-input
                  id="input-phone-extra"
                  name="input-phone-extra"
                  type="text"
                  class="shadow-none"
                  placeholder="Ej. 5537081925, +525537081925"
                  v-model.trim="form.contact.phoneExtra"
                  :maxlength="16"
                  v-validate="{ regex: regexPhone  }"
                  :state="validateState('input-phone-extra')"
                  aria-describedby="input-phone-extra-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-phone-extra-feedback">Introduzca un teléfono válido</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
        </b-card>

        <!-- DIRECCION FISCAL -->
        <b-card id="address" header="Dirección fiscal" class="form-section">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-street"
                label="Calle *"
                label-for="input-street">
                <b-form-input
                  id="input-street"
                  name="input-street"
                  type="text"
                  class="shadow-none"
                  placeholder="Calle"
                  v-model.trim="form.address.streetAddress"
                  :maxlength="255"
                  v-validate="{ required: true  }"
                  :state="validateState('input-street')"
                  aria-describedby="input-street-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-street-feedback">La calle es requerida</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-zipcode"
                label="Código postal *"
                label-for="input-zipcode">
                <b-form-input
                  id="input-zipcode"
                  name="input-zipcode"
                  type="text"
                  class="shadow-none"
                  placeholder="Código postal"
                  v-model.trim="form.address.zipcode"
                  :maxlength="5"
                  v-validate="{ required: true, regex: regexZipCode  }"
                  :state="validateState('input-zipcode')"
                  aria-describedby="input-zipcode-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-zipcode-feedback">Introduzca un código postal válido</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-num-ext"
                label="Número exterior *"
                label-for="input-num-ext">
                <b-form-input
                  id="input-num-ext"
                  name="input-num-ext"
                  type="text"
                  class="shadow-none"
                  placeholder="Número exterior"
                  v-model.trim="form.address.extNumAddress"
                  :maxlength="10"
                  v-validate="{ required: true }"
                  :state="validateState('input-num-ext')"
                  aria-describedby="input-num-ext-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-num-ext-feedback">El número exterior es requerido</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-num-int"
                label="Número interior"
                label-for="input-num-int">
                <b-form-input
                  id="input-num-int"
                  name="input-num-int"
                  type="text"
                  class="shadow-none"
                  placeholder="Número interior"
                  v-model.trim="form.address.intNumAddress"
                  :maxlength="10"
                  v-validate="{ required: false }"
                  :state="validateState('input-num-int')"
                  :disabled="readOnly">
                </b-form-input>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group id="input-group-country" label="País *">
                <b-form-select
                  id="input-select-country"
                  name="input-select-country"
                  class="shadow-none"
                  v-model="form.address.country"
                  :options="countriesOptions"
                  v-validate="{ required: true }"
                  :state="validateState('input-select-country')"
                  :disabled="readOnly">
                </b-form-select>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group v-if="form.address.country === 'México'" id="input-group-state-mex" label="Estado *">
                <b-form-select
                  id="input-select-state-mex"
                  name="input-select-state-mex"
                  class="shadow-none"
                  v-model="form.address.state"
                  :options="mexicoStatesOptions"
                  v-validate="{ required: true }"
                  :state="validateState('input-select-state-mex')"
                  aria-describedby="input-select-state-mex-feedback"
                  :disabled="readOnly">
                </b-form-select>
                <b-form-invalid-feedback id="input-select-state-mex-feedback">El estado es requerido</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group v-else
                id="input-group-state-other"
                name="input-group-state-other"
                label="Estado *"
                label-for="input-state-other">
                <b-form-input
                  id="input-state-other"
                  name="input-state-other"
                  type="text"
                  class="shadow-none"
                  placeholder="Estado"
                  v-model.trim="form.address.state"
                  :maxlength="255"
                  v-validate="{ required: true }"
                  :state="validateState('input-state-other')"
                  aria-describedby="input-state-other-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-state-other-feedback">El estado es requerido</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-delegation"
                label="Delegación/Municipio *"
                label-for="input-delegation">
                <b-form-input
                  id="input-delegation"
                  name="input-delegation"
                  type="text"
                  class="shadow-none"
                  placeholder="Delegación/Municipio"
                  v-model.trim="form.address.delegation"
                  :maxlength="255"
                  v-validate="{ required: true }"
                  :state="validateState('input-delegation')"
                  aria-describedby="input-delegation-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-delegation-feedback">La delegación o municipio es requerido</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-district"
                label="Colonia *"
                label-for="input-district">
                <b-form-input
                  id="input-district"
                  name="input-district"
                  type="text"
                  class="shadow-none"
                  placeholder="Colonia"
                  v-model.trim="form.address.district"
                  :maxlength="255"
                  v-validate="{ required: true }"
                  :state="validateState('input-district')"
                  aria-describedby="input-district-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-district-feedback">La colonia es requerida</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
        </b-card>

        <!-- DATOS ADICIONALES -->
        <b-card id="other" header="Datos adicionales" class="form-section">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-comercial-charge"
                label="Comercial a cargo"
                label-for="input-comercial-charge">
                <b-form-input
                  id="input-comercial-charge"
                  name="input-comercial-charge"
                  type="text"
                  class="shadow-none"
                  placeholder="Clave (4 dígitos)"
                  v-model.trim="form.comercialCharge"
                  :maxlength="4"
                  v-validate="{ required: false, regex: regexComercialCharge }"
                  :state="validateState('input-comercial-charge')"
                  aria-describedby="input-comercial-charge-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-comercial-charge-feedback">Introduzca un número de 4 dígitos</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-licenses"
                label="Mínimo de licencias"
                label-for="input-licenses">
                <b-form-input
                  id="input-licenses"
                  name="input-licenses"
                  type="number"
                  class="shadow-none"
                  placeholder="0"
                  v-model="form.minimumLicenses"
                  v-validate="{ required: false, regex: regexMinLicenses }"
                  :state="validateState('input-licenses')"
                  aria-describedby="input-licenses-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-licenses-feedback">El número excede el rango permitido</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-start-date"
                label="Fecha de inicio del contrato">
                <DateSelector
                  format="DD/MM/YYYY"
                  :editable="false"
                  :clearable="true"
                  v-model="form.startDate"
                  placeholder="dd/mm/aaaa"
                  :disabled="readOnly"/>
              </b-form-group>
            </div>
          </div>
        </b-card>

        <!-- ACCIONES -->
        <div class="text-right">
          <b-button class="mr-2" size="lg" @click="onCancel">Cancelar</b-button>
          <b-button type="submit" variant="primary" size="lg" v-if="!readOnly">Guardar cliente</b-button>
        </div>
      </b-form>

      <LoadingMask :active="loading"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Client, ClientStatus, JuridicalPerson } from '@/types/Catalogs'
import DateSelector from '@/components/generic/DateSelector.vue'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import { MessageError } from '@/components/generic/MessageHandling.vue'
import catalogsService from '@/services/CatalogsService'
import { RoleNames } from '@/types/Auth'
import userInfoStore from '@/store/userInfo'
import moment from 'moment'
import DateFormat from '@/services/DateFormat'
import { CLIENT_REGEXPS } from '@/types/RegExpressions'

@Component({
  components: {
    DateSelector,
    LoadingMask,
    MessageError
  }
})
export default class AdminClientForm extends Vue {
  @Prop({ required: true, default: 0 })
  id: number

  @Prop({ required: true, default: '' })
  title: string

  @Prop({ required: false, default: false })
  readOnly: boolean

  @Prop({ required: false, default: false })
  editButton: boolean

  loading = false

  form = Client.getIntanceForEdit()
  statusOptions: any[] = []
  juridicalPersonOptions = [
    { value: JuridicalPerson.MORAL, text: 'Persona moral' },
    { value: JuridicalPerson.PHYSICAL, text: 'Persona física' }
  ]
  countriesOptions = catalogsService.getCountries().map(it => { return { value: it, text: it } })
  mexicoStatesOptions = [ { value: '', text: '-- Seleccione estado --' } ].concat(catalogsService.getMexicoStates().map(it => { return { value: it, text: it } }))
  regexRfcPersonaFisica = CLIENT_REGEXPS.regexRfcPersonaFisica
  regexRfcPersonaMoral = CLIENT_REGEXPS.regexRfcPersonaMoral
  regexPhone = CLIENT_REGEXPS.regexPhone
  regexZipCode = CLIENT_REGEXPS.regexZipCode
  regexComercialCharge = CLIENT_REGEXPS.regexComercialCharge
  regexMinLicenses = CLIENT_REGEXPS.regexMinLicenses
  regexClientCode = CLIENT_REGEXPS.regexClientCode
  regexStpClabe = CLIENT_REGEXPS.regexStpClabe

  creationDate = ''
  updateDate = ''
  verificationDate = ''

  clientBackup = ''

  mounted () {
    this.init()
  }

  init () {
    if (this.id) {
      this.loading = true
      catalogsService.getClientById(this.id).then(data => {
        data.address.intNumAddress = data.address.intNumAddress || ''
        data.comercialCharge = data.comercialCharge || ''
        data.minimumLicenses = data.minimumLicenses || 0
        data.startDate = data.startDate ? moment(data.startDate).toDate() : '' as any

        this.creationDate = new DateFormat(data.creationDate).toDateTimeString() // moment(data.creationDate).format('MMMM DD, YYYY - HH:mm')
        this.verificationDate = data.verificationDate ? new DateFormat(data.verificationDate).toDateTimeString() : '- - / - - / - - - -'
        this.updateDate = data.updateDate ? new DateFormat(data.updateDate).toDateTimeString() : ' - - / - - / - - - -'

        this.form = data
        this.clientBackup = JSON.stringify(this.form)
        this.createStatusOptions()
        this.$validator.reset()
      }).finally(() => {
        this.loading = false
      })
    } else {
      this.createStatusOptions()
    }
  }

  validateState (ref: any) {
    const thiz = this as any
    if (
      thiz.veeFields[ref] &&
      (thiz.veeFields[ref].dirty || thiz.veeFields[ref].validated)
    ) {
      return !thiz.veeErrors.has(ref)
    }
    return null
  }

  onSubmit () {
    this.$validator.validateAll().then(result => {
      if (result) {
        if (JSON.stringify(this.form) === this.clientBackup) {
          // If there are no changes then return to main grid
          this.onCancel()
          return
        }

        this.loading = true
        this.form.updateDate = new Date()
        catalogsService.saveClient(this.form).then((response: Client) => {
          this.form.id = response.id
          this.$emit('saved', this.form)
        }).catch((error) => {
          let messageValues = {
            title: 'Error al guardar el cliente.',
            message: '',
            delay: 10000,
            error: error
          }
          let errorComponent = new MessageError({ propsData: messageValues })
          errorComponent.displayMessage()
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$bvToast.toast('Revise los campos marcados con error', {
          title: 'Errores en el formulario',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 4500
        })
      }
    })
  }

  onEdit () {
    this.$emit('edit')
  }

  onCancel () {
    this.$emit('close')
  }

  createStatusOptions () {
    this.statusOptions = [
      { value: ClientStatus.APROBACION, text: 'En aprobación', disabled: true },
      { value: ClientStatus.ACTIVO, text: 'Activo', disabled: true },
      { value: ClientStatus.SUSPENDIDO, text: 'Suspendido', disabled: true },
      { value: ClientStatus.BAJA, text: 'Baja', disabled: true }
    ]

    if (this.form.id) {
      switch (userInfoStore.userInfo.role.name) {
        case RoleNames.FINANCES_CONTROL:
          switch (this.form.status) {
            case ClientStatus.APROBACION:
              this.statusOptions[0].disabled = false
              this.statusOptions[1].disabled = false
              break
          }
          break
        case RoleNames.FINANCES_ADMIN:
          switch (this.form.status) {
            case ClientStatus.APROBACION:
              this.statusOptions[3].disabled = false
              break
          }
          break
      }
    } else {
      switch (userInfoStore.userInfo.role.name) {
        case RoleNames.FINANCES_CONTROL:
          this.form.status = ClientStatus.ACTIVO
          break
        case RoleNames.FINANCES_ADMIN:
          this.form.status = ClientStatus.APROBACION
          break
      }
    }
  }
}
</script>
